import React from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import UIStore from '../../../store/UIStore';
import BarcodeSearchButton from './BarcodeSearchButton';
import BarcodeSearchModal from './BarcodeSearchModal';

const BarcodeSearch = ({ uiStore }) => {
  return (
    <>
      <BarcodeSearchButton />
      {uiStore.barcodeReaderModal.isOpen && <BarcodeSearchModal />}
    </>
  );
};

BarcodeSearch.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
};

export default inject('uiStore')(observer(BarcodeSearch));
